import { useState } from 'react';
import {useEffect} from 'react';
import './App.css';

function App() {
  
  const [item,setItem]= useState(()=>JSON.parse(localStorage.getItem('item') || '[]') )
  const[title,setTitle]=useState('')
  const[amount,setAmount]= useState(0)
 
useEffect(()=>{localStorage.setItem('item',JSON.stringify(item)) 
},[item])


function addExpense(){
  if (title.trim()!=='' &&  amount>0){

    setItem([...item,{id:Date.now(),title:title,amount:amount}])
    setTitle('')
    setAmount(0)

}

}

function deleteitem(id){
  setItem(item.filter((e)=>e.id!==id))
}


  return (
    <div className='app'>
      <h1>Expense Tracker</h1>
      <h2>Track your expenses</h2>
      <input type='input'value={title} onChange={(e)=>setTitle(e.target.value)} />
      <input type='number' value={amount} onChange={(e)=>setAmount(parseFloat(e.target.value))}/>
      <button className='btn-add' onClick={addExpense}>Add Expense</button>
      <span><h3>{item.map((e,index)=><li key={index}>{e.title}: {e.amount}
        <button className='btn-delete' key={index} onClick={() => deleteitem(e.id)}>Delete</button>
      </li>)}
      
      </h3>
</span>


<span>Total Expenses :{item.reduce((total,expense)=>expense.amount+total,0)}</span>


    </div>
  );
}

export default App;
